function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { stroke-width: 6 }\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Outline"
}, /*#__PURE__*/React.createElement("path", {
  id: "<Compound Path>",
  fillRule: "evenodd",
  className: "shp0",
  d: "M484 259C537.02 259 580 301.98 580 355C580 408.02 537.02 451 484 451C430.98 451 388 408.02 388 355C388.06 302.01 431.01 259.06 484 259ZM420 355C420 390.35 448.65 419 484 419C519.35 419 548 390.35 548 355C548 319.65 519.35 291 484 291C448.67 291.04 420.04 319.67 420 355Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "<Compound Path>",
  fillRule: "evenodd",
  className: "shp0",
  d: "M372 452.07L596 452.07C631.33 452.11 659.96 480.74 660 516.07L660 531L740 531C740.66 531 741.33 531.04 741.98 531.12C750.75 532.22 756.97 540.22 755.88 548.98L723.88 804.98C722.88 812.99 716.07 819 708 819L260 819C251.93 819 245.12 812.99 244.12 804.98L212.12 548.98C212.04 548.33 212 547.66 212 547C212 538.16 219.16 531 228 531L308 531L308 516.07C308.04 480.74 336.67 452.11 372 452.07ZM246.12 563L274.12 787L693.88 787L721.88 563L246.12 563ZM596 484.07L372 484.07C354.34 484.09 340.02 498.4 340 516.07L340 531L628 531L628 516.07C627.98 498.4 613.66 484.09 596 484.07Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "<Path>",
  className: "shp0",
  d: "M212 851L756 851L756 883L212 883L212 851Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "<Compound Path>",
  fillRule: "evenodd",
  className: "shp0",
  d: "M420 675C420 639.65 448.65 611 484 611C519.35 611 548 639.65 548 675C548 710.35 519.35 739 484 739C448.67 738.96 420.04 710.33 420 675ZM452 675C452 692.67 466.33 707 484 707C501.67 707 516 692.67 516 675C516 657.33 501.67 643 484 643C466.34 643.02 452.02 657.34 452 675Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "<Compound Path>",
  fillRule: "evenodd",
  className: "shp0",
  d: "M957.03 349.3C963.62 354.28 964.96 363.64 960.03 370.26L920.67 423.17C918.28 426.38 914.7 428.51 910.73 429.08C910.03 429.18 909.32 429.23 908.61 429.23C905.34 429.23 902.15 428.16 899.54 426.19L868 402.34L868 947C868 955.84 860.84 963 852 963L116 963C107.16 963 100 955.84 100 947L100 400.83L66.45 426.19C66.42 426.21 66.39 426.24 66.35 426.26C59.69 431.21 50.28 429.83 45.33 423.17L5.97 370.26C1.04 363.63 2.38 354.28 8.97 349.3L454.25 12.6C471.28 -0.2 494.72 -0.2 511.75 12.6L957.03 349.3L957.03 349.3ZM836 378.14L483 111.22L132 376.63L132 931L836 931L836 378.14ZM927 364.28L493.63 36.58C487.34 31.85 478.69 31.85 472.4 36.58L39 364.28L60.41 393.07L473.93 80.39C479.3 76.33 486.7 76.33 492.07 80.39L905.6 393.07L927 364.28Z"
}));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 966 966",
    width: 966,
    height: 966,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f7fde456.svg";
export { ForwardRef as ReactComponent };